import React from 'react';
import ExternalSvg from 'components/ExternalSvg';
import { AshaIconProps } from '../types';

const AshaSides = ({ width = '24px', height = '24px' }: AshaIconProps) => (
  <ExternalSvg customer="asha" iconName="ashaSides" width={width} height={height} />
);

export default AshaSides;
